import { useLogger } from '@lumahealthhq/ui-utils';
import useCurrentAuth from './useCurrentAuth';
export default function useCurrentMaster(args) {
  const auth = useCurrentAuth();
  const logger = useLogger();
  if (!auth && !(args != null && args.ignoreError)) {
    logger.error('Auth has not been initialized yet');
    // @ts-expect-error prefer to hack the return type since this is an exception
    return undefined;
  }
  // @ts-expect-error
  return auth == null ? void 0 : auth.currentMaster;
}